import { Route, Routes } from "react-router-dom";
import List from "./List";

function MrReports(props) {
  return (
    <>
      <Routes>
        <Route path="/" element={<List {...props} />} />
      </Routes>
    </>
  );
}

export default MrReports;
